import React from 'react';
import methodModel from '../../../methods/methods';
import { Link } from 'react-router-dom';
import './style.scss';
import PhoneInput from 'react-phone-input-2';
import ImageUpload from '../../common/ImageUpload';
import { useState, useEffect, useRef } from 'react';

const Html = ({
  handleSubmit,
  setForm,
  setRemoveImage,
  // ExtractMobileNo,
  RemoveImage,
  history,
  form,
  getError,
  submitted,
  imageResult,
  uploadImage,
  images,
  remove,
  // fileInputRef
}) => {
  const fileInputRef = useRef(null);

  return (
    <>
      <div className="wrapper_section">
        <div className="flex items-center  justify-between am:col-span-12 md:col-span-4 p-4 shadow-box rounded-lg bg-white">
          <div className="flex items-center">
            {/* <button
              onClick={() => {
                history(-1);
              }}
              type="button"
              className="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            >
              <i className="fa fa-angle-left text-lg"></i>
            </button> */}
            <div>
              <h3 className="text-2xl font-semibold text-[#111827]">
                Edit Profile
              </h3>
            </div>
          </div>
        </div>
        <form name="profileForm" className="" onSubmit={handleSubmit}>
          <div className="inner_part mt-5">
            <div className="grid grid-cols-12 gap-4 ">
              <div className="am:col-span-12 md:col-span-4 p-6 shadow-box rounded-lg bg-white">
                <div className="flex items-center justify-center h-[100%]">
                  <div className="">
                    {/* <label className="font-bold text-gray-600 text-md">
                    Image
                  </label> */}

                    <div className="col-span-12 md:col-span-6 text-center">
                      <div className="flex items-center justify-center h-[100%]">
                        <div className="imagethumbWrapper ">
                          {form?.image ? (
                            <>
                              <img
                                src={methodModel.userImg(form && form?.image)}
                                className="h-[200px] w-[200px] mx-auto  rounded-full object-cover p-1 shadow-md"
                              />
                              <i
                                className="fa fa-times relative top-[45px]"
                                title="Remove"
                                onClick={() => {
                                  setRemoveImage(form?.image);
                                  fileInputRef.current.value = '';
                                  setForm({ ...form, image: '' });
                                }}
                              ></i>
                            </>
                          ) : null}
                          {!form?.image ? (
                            <>
                              <img
                                src={methodModel.userImg(form && form?.image)}
                                className="h-[200px] w-[200px] mx-auto  rounded-full object-cover p-1 shadow-md"
                              />
                            </>
                          ) : null}
                        </div>
                      </div>
                      <label
                        className={`inline-block mt-4 cursor-pointer text-white bg-[#A12238] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 ${
                          form?.image ? 'd-none' : ''
                        }`}
                      >
                        <input
                          type="file"
                          className="d-none"
                          accept="image/*"
                          ref={fileInputRef}
                          onChange={(e) => {
                            uploadImage(e);
                          }}
                        />
                        {'Upload Image'}
                      </label>
                    </div>
                    {submitted && getError('image')?.invalid ? (
                      <div className="invalid-feedback d-block">
                        Image is required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-span-8 md:col-span-8 p-6 shadow-box rounded-lg bg-white">
                <div className="mb-3">
                  <label className="text-typo text-base font-medium max-w-sm w-full block">
                   First Name
                  </label>
                  <div className="sub_fatch">
                    <div>
                      <input
                        type="text"
                        className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                        placeholder="Enter First Name"
                        name="firstName"
                        value={form.firstName}
                        onChange={(e) => {
                          let inputData = e.target.value;
                          let filteredValue = inputData.replace(
                            /[^A-Za-z ]/gi,
                            ''
                          );
                          setForm({ ...form, firstName: filteredValue });
                        }}
                        required
                      />
                      {submitted && getError('firstName')?.invalid ? (
                        <div className="invalid-feedback d-block">
                          First Name is required
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="text-typo text-base font-medium max-w-sm w-full block">
                    Last Name
                  </label>
                  <div className="sub_fatch">
                    <div>
                      <input
                        type="text"
                        className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                        placeholder="Enter Last Name"
                        name="lastName"
                        value={form.lastName}
                        onChange={(e) => {
                          let inputData = e.target.value;
                          let filteredValue = inputData.replace(
                            /[^A-Za-z ]/gi,
                            ''
                          );
                          setForm({ ...form, lastName: filteredValue });
                        }}
                        required
                      />
                      {submitted && getError('lastName')?.invalid ? (
                        <div className="invalid-feedback d-block">
                         Last Name is required
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="text-typo text-base font-medium max-w-sm w-full block">
                    Email
                  </label>
                  <div className="sub_fatch">
                    <div>
                      <input
                        type="email"
                        className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                        placeholder="Enter Name"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        value={form.email ? form.email : ''}
                        disabled
                      />
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <label className="text-typo text-base font-medium max-w-sm w-full block">
                    Mobile No.
                  </label>
                  <div className="sub_fatch">
                    <div className="reactphone">
                      <PhoneInput
                        className="w-full"
                        value={form?.dialCode + form?.mobileNo}
                        enableSearch={true}
                        // minLength={10}

                        required
                        onChange={(phone, code) => {
                          let phonenumber = phone.replace(code.dialCode, '');
                          setForm({
                            ...form,
                            mobileNo: phonenumber,
                            dialCode: code?.dialCode,
                          });
                        }}
                        countryCodeEditable={true}
                      />
                      {submitted && form.mobileNo?.length < 10 ? (
                        <div className="invalid-feedback d-block">
                          Mobile No. is required
                        </div>
                      ) : (
                        <></>
                      )}

                      {submitted && form?.mobileNo < 10 ? (
                        <div className="invalid-feedback d-block">
                          Min Length is 10
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <div className="flex justify-end gap-3 items-end">
                    <Link
                      to="/profile"
                      className="text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                    >
                      Discards
                    </Link>
                    <button
                      type="submit"
                      className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/* 
        <form name="profileForm" className="" onSubmit={handleSubmit}>
          <div className="inner_part sm:mt-3 md:mt-8 p-6 shadow-box rounded-lg bg-white">
            <div className="grid items-center grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2">
                <div className="text_head">
                  <label className="font-bold text-gray-600 text-md">
                    Image
                  </label>
                </div>
              </div>
              <div className="col-span-12 md:col-span-10">
                <div className="sub_fatch flex items-center">
             
                  <div className="profile_btn ">
                
                    <div className="col-span-12 md:col-span-6">
                      <ImageUpload
                        model="users"
                        result={(e) => imageResult(e, 'image')}
                        value={images?.image || form.image}
                        multiple={false}
                      />
                    </div>
        
                    {submitted && getError('image')?.invalid ? (
                      <div className="invalid-feedback d-block">
                        Image is required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-span-12 md:col-span-2">
                <div className="text_head">
                  <label className="font-bold text-gray-600 text-md">
                    Name
                  </label>
                </div>
              </div>
              <div className="col-span-12 md:col-span-10">
                <div className="sub_fatch">
                  <div>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      placeholder="Enter Name"
                      name="fullName"
                      value={form.fullName}
                      onChange={(e) =>
                        setForm({ ...form, fullName: e.target.value })
                      }
                      required
                    />
                    {submitted && getError('fullName')?.invalid ? (
                      <div className="invalid-feedback d-block">
                        Name is required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-span-12 md:col-span-2">
                <div className="text_head">
                  <label className="font-bold text-gray-600 text-md">
                    Email
                  </label>
                </div>
              </div>
              <div className="col-span-12 md:col-span-10">
                <div className="sub_fatch">
                  <div>
                    <input
                      type="email"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      placeholder="Enter Name"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      value={form.email ? form.email : ''}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="col-span-12 md:col-span-2">
                <div className="text_head">
                  <label className="font-bold text-gray-600 text-md">
                    Mobile No.
                  </label>
                </div>
              </div>
              <div className="col-span-12 md:col-span-10">
                <div className="sub_fatch">
                  <div className="reactphone">
                    <PhoneInput
                      className="w-full"
                      country={'us'}
                      value={form.mobileNo}
                      enableSearch={true}
                      limitMaxLength
                      minLength={10}
                      required
                      onChange={(e, c) => {
                        setForm({
                          ...form,
                          dialCode: c?.dialCode,
                          mobileNo: e,
                        });
                      }}
                      countryCodeEditable={true}
                    />
                    {form.mobileNo?.length < 10 ? (
                      <div className="invalid-feedback d-block">
                        Mobile No. is invalid
                      </div>
                    ) : (
                      <></>
                    )}
           
                    {submitted && form?.mobileNo < 10 ? (
                      <div className="invalid-feedback d-block">
                        Min Length is 10
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

           

              <div className="col-span-12 sm:mt-4 md:mt-4">
                <div className="flex justify-end gap-3 items-end">
                  <Link
                    to="/profile"
                    className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                  >
                    Discards
                  </Link>
                  <button
                    type="submit"
                    className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form> */}
      </div>
    </>
  );
};

export default Html;
